import { render } from "./SystemMenu.vue?vue&type=template&id=157d45c9&scoped=true"
import script from "./SystemMenu.vue?vue&type=script&lang=js"
export * from "./SystemMenu.vue?vue&type=script&lang=js"

import "./SystemMenu.vue?vue&type=style&index=0&id=157d45c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157d45c9"]])

export default __exports__